import React, { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import RouteUrlPaths from '../../RouteUrlPaths';
import ManageUserAccessStore from '../../stores/ManageUserAccessStore';

interface RequirePersonalDetailsConfirmationProps {
  manageUserAccessStore: ManageUserAccessStore;
}

const RequirePersonalDetailsConfirmation: FC<
  PropsWithChildren<RequirePersonalDetailsConfirmationProps>
> = observer(({ manageUserAccessStore, children }) => {
  const location = useLocation();
  const isOnConfirmationPage = location.pathname === `/${RouteUrlPaths.ConfirmPersonalDetails}`;

  if (manageUserAccessStore.shouldForceConfirmPersonalDetails() && !isOnConfirmationPage) {
    return <Navigate to={RouteUrlPaths.ConfirmPersonalDetails} replace />;
  }

  return children as React.ReactElement;
});

export default RequirePersonalDetailsConfirmation;
